import { RichTextNode, RichTextNodeKind } from '@griply/types';
import React from 'react';
import { LinkBaseProps, LinkedText } from 'shared/components/ui/url-parser';

import * as Styled from './rich-text.style';

export type RichTextNodesProps = {
  nodes: RichTextNode[];
  linkComponent?: React.ComponentType<LinkBaseProps>;
};

// One node per element. Text runs still go through UrlParser so bare URLs, emails and phone
// numbers stay clickable inside formatted descriptions.
export const RichTextNodes: React.FC<RichTextNodesProps> = ({
  nodes,
  linkComponent: Link,
}) => (
  <>
    {nodes.map((node, index) => {
      const key = `${node.kind}-${index}`;

      switch (node.kind) {
        case RichTextNodeKind.Text:
          return (
            <LinkedText key={key} value={node.value} linkComponent={Link} />
          );
        case RichTextNodeKind.Break:
          return <br key={key} />;
        case RichTextNodeKind.Paragraph:
          return (
            <Styled.Paragraph key={key}>
              <RichTextNodes nodes={node.children} linkComponent={Link} />
            </Styled.Paragraph>
          );
        case RichTextNodeKind.Block:
          return (
            <Styled.Block key={key}>
              <RichTextNodes nodes={node.children} linkComponent={Link} />
            </Styled.Block>
          );
        case RichTextNodeKind.List: {
          const ListTag = node.ordered ? Styled.OrderedList : Styled.List;
          return (
            <ListTag key={key}>
              <RichTextNodes nodes={node.children} linkComponent={Link} />
            </ListTag>
          );
        }
        case RichTextNodeKind.ListItem:
          return (
            <Styled.ListItem key={key}>
              <RichTextNodes nodes={node.children} linkComponent={Link} />
            </Styled.ListItem>
          );
        case RichTextNodeKind.Link:
          return (
            <a key={key} href={node.href} target="_blank" rel="noreferrer">
              <RichTextNodes nodes={node.children} linkComponent={Link} />
            </a>
          );
        case RichTextNodeKind.Bold:
          return (
            <strong key={key}>
              <RichTextNodes nodes={node.children} linkComponent={Link} />
            </strong>
          );
        case RichTextNodeKind.Italic:
          return (
            <em key={key}>
              <RichTextNodes nodes={node.children} linkComponent={Link} />
            </em>
          );
        default:
          return (
            <u key={key}>
              <RichTextNodes nodes={node.children} linkComponent={Link} />
            </u>
          );
      }
    })}
  </>
);
